export function isErrorMessage(error) {
    var _a;
    return ((_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.error) !== undefined;
}
export const BYTES_UNIT = ["TB", "GB", "MB", "KB"];
//# sourceMappingURL=common.js.map